import type { ReactNode } from 'react';

import { HotelReviewsContext } from './contexts/HotelReviewsContext';
import useHotelReviewsStore from './stores/useHotelReviewsStore';

import type { UBFFGateway } from '@shared/types/frontend/ubff-gateway';

import { withUBFFContext } from '@shared/data-access-frontend/contexts/ubff-context';

const HotelReviewsProvider = ({
  children,
  hotelId,
  locale,
  uBFFGateway,
}: {
  children: ReactNode;
  hotelId: string;
  uBFFGateway: UBFFGateway;
  locale: string;
}) => {
  const store = useHotelReviewsStore(hotelId, locale, uBFFGateway);

  return (
    <HotelReviewsContext.Provider value={store}>
      {children}
    </HotelReviewsContext.Provider>
  );
};

export default withUBFFContext(HotelReviewsProvider);
